import { Component, OnInit } from '@angular/core';
import { IMAGE_PROFILE_ID_SUPPORTED_TYPES } from 'src/app/constant/constant';
import { SupportMetadata, UpdateProviderMetadata } from 'src/app/models/provider';
import { ApiResult } from 'src/app/models/PromiseResult';
import { ChangeDetectorRef } from '@angular/core';
import { ProviderStateService } from 'src/app/services/provider-state.service';
import { Form_Data } from 'src/app/models/util.models';
import { ProviderService } from 'src/app/services/provider.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageService } from 'primeng';
import { name_input, address, city, phoneNumber, zipCode, textareaBox, dose_input, number_input } from 'src/app/constant/constant';
import { GraphqlService } from 'src/app/services/graphql.service';

@Component({
  selector: 'app-update-logo',
  templateUrl: './update-logo.component.html',
  styleUrls: ['./update-logo.component.css', '../../../../../assets/css/custom-egd.css'],
  providers: [MessageService]
})
export class UpdateLogoComponent implements OnInit {
  createDialog: boolean = false;
  createDialogDetails: boolean = false;
  image_types: string[] = IMAGE_PROFILE_ID_SUPPORTED_TYPES;
  file: File;
  uploadFile: File;
  posting: boolean;
  provider_id: string = '';
  provider_name: string = '';
  logo_url: string = '';
  phone_number: number = 0;
  email: string = '';
  address1: string = '';
  is_primary_provider: boolean = false;
  provider_img: string;
  updatemetadata: UpdateProviderMetadata = new UpdateProviderMetadata();
  updatesupportdata: SupportMetadata = new SupportMetadata();
  readonly name_input: RegExp = name_input;
  readonly address: RegExp = address;
  readonly city_input: RegExp = city;
  readonly phoneNumber: RegExp = phoneNumber;
  readonly zipCode: RegExp = zipCode;
  readonly textarea: RegExp = textareaBox;
  readonly dose_input: RegExp = dose_input;
  readonly number_input: RegExp = number_input;

  constructor(
    private readonly providerstateService: ProviderStateService,
    private readonly providerService: ProviderService,
    private readonly messageService: MessageService,
    private readonly cdr: ChangeDetectorRef,
    private readonly graphqlService: GraphqlService
  ) { }

  ngOnInit(): void {
    // this.updatemetadata.api_data.fetchProviderMetadata.metadata.images.logo.default = '';
    this.provider_img = this.providerstateService.getLogoUrl();
    this.provider_name = this.providerstateService.getProviderName();
    this.provider_id = this.providerstateService.getProviderId();
    this.fetchProvidereMetada();
    this.cdr.detectChanges();
    this.updatesupportdata.api_data = {
      contact: {
        support: {
          phoneNumber: null,
          email: '',
          address: ''
        }
      }
    };
  }
  showDialogToAdd() {
    this.createDialog = true;
  }

  showDialogToAddDetails() {
    this.createDialogDetails = true;
  }
  Cancel() {
    this.createDialog = false;
  }

  Cancel1() {
    this.createDialogDetails = false;
  }
  uploadFiles(file: File[]) {
    if (this.image_types.includes(file[0].type.toLowerCase())) {
      if (file[0].size > 5033165) {
        // this.fileu=true;
        this.file = null;
      } else if (file[0].size < 5033165) {
        // this.fileu=false;
        this.file = file[0];
      }
    } else this.file = null;
  }
  async save() {
    this.updatemetadata.create_api_result = new ApiResult(true);
    this.updatemetadata.api_data.file = this.file;
    this.posting = true; // Start posting
    this.updatemetadata.form_data = new Form_Data();
    this.updatemetadata.form_data.form_data =
      this.updatemetadata.form_data.create_form_data(
        this.updatemetadata.api_data,
        new FormData(),
        ''
      );
    await this.providerService
      .UpdateProviderLogo(this.updatemetadata.form_data.form_data)
      .toPromise()
      .then(async (result) => {
        if (result.success) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Logo Added Successfully'
          });

          this.createDialog = false;
          this.posting = false;
          this.file = null;
          const newLogoUrl = result.data.providerMetadata.metadata.images.logo.default;
          this.providerstateService.setLogoUrl(newLogoUrl);
          this.provider_img = newLogoUrl;
          this.cdr.detectChanges();
          location.reload();
        }
      })
      .catch((error: HttpErrorResponse) => {
        this.updatemetadata.create_api_result.ServerError.error = error.error;
        this.updatemetadata.create_api_result.PromiseResult.data.response.success =
          false;
        this.posting = false;
      });

  }

  async UpdateSupportDetails() {
    this.updatesupportdata.create_api_result = new ApiResult(true);
    this.posting = true;
    const metadata = {
      contact: {
        support: {
          phoneNumber: this.updatesupportdata.api_data.contact.support.phoneNumber,
          email: this.updatesupportdata.api_data.contact.support.email,
          address: this.updatesupportdata.api_data.contact.support.address
        }
      }
    };
    await this.graphqlService.updateProviderMetadata(metadata)
      .toPromise()
      .then(async (result) => {
        if (result) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Information Successfully'
          });

          this.createDialogDetails = false;
          this.posting = false;
          this.file = null;
          this.cdr.detectChanges();
          location.reload();
        }
      })
      .catch((error: HttpErrorResponse) => {
        this.updatesupportdata.create_api_result.ServerError.error = error.error;
        this.updatesupportdata.create_api_result.PromiseResult.data.response.success =
          false;
        this.posting = false;
      });

  }

  async fetchProvidereMetada() {
    await this.graphqlService.fetchProviderMetadata(this.provider_id).subscribe(
     (result) => {
        if (result) {
          this.phone_number = result['metadata']['contact']['support']['phoneNumber'],
          this.email = result.metadata.contact.support.email,
          this.address1 = result.metadata.contact.support.address
        }
      
      })
      
  }

  clearfile()
  {
    this.file = null;
  }

  isPosting(): boolean {
    return this.updatemetadata.create_api_result.Posting;
  }
}
